import * as React from 'react';
export const IcTrolleyClearance = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.5 10h9a1 1 0 001-1A5.17 5.17 0 0013 4.08.193.193 0 0013 4a1 1 0 00-2 0 .19.19 0 000 .08A5.17 5.17 0 006.5 9a1 1 0 001 1zm14.31 1.42A1.002 1.002 0 0021 11H3a1 1 0 00-.81.42 1 1 0 00-.14.9l2 6A1 1 0 005 19h1.59a1.64 1.64 0 00-.09.5 1.5 1.5 0 003 0 1.64 1.64 0 00-.09-.5h5.18c-.056.161-.086.33-.09.5a1.5 1.5 0 103 0 1.645 1.645 0 00-.09-.5H19a1 1 0 00.95-.68l2-6a1.002 1.002 0 00-.14-.9z'
      fill='currentColor'
    />
  </svg>
);
